import React from 'react';

import { LoadingOverlay } from '../layout/LoadingOverlay';

const LoadingScreen = () => (
   <div>
      <h2 className="sr-only">Loading...</h2>
      <LoadingOverlay />
   </div>
);

export { LoadingScreen };
